var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.364 6.636C41.664 4.936 39.404 4 37 4s-4.664.936-6.364 2.636l-5 5c-1.445 1.445-2.338 3.295-2.574 5.294C23.021 17.282 23 17.64 23 18c0 1.368.313 2.686.888 3.884l1.526-1.526C25.147 19.61 25 18.817 25 18c0-1.87.728-3.627 2.05-4.95l5-5C33.373 6.728 35.13 6 37 6s3.627.728 4.95 2.05S44 11.13 44 13s-.728 3.627-2.05 4.95l-5 5C35.627 24.272 33.87 25 32 25c-.817 0-1.61-.147-2.358-.414l-1.526 1.526C29.314 26.687 30.632 27 32 27c2.404 0 4.664-.936 6.364-2.636l5-5C45.064 17.664 46 15.404 46 13S45.064 8.336 43.364 6.636zM24.586 29.642C24.853 30.39 25 31.183 25 32c0 1.87-.728 3.627-2.05 4.95l-5 5C16.627 43.272 14.87 44 13 44s-3.627-.728-4.95-2.05S6 38.87 6 37s.728-3.627 2.05-4.95l5-5C14.373 25.728 16.13 25 18 25c.817 0 1.61.147 2.358.414l1.526-1.526C20.686 23.313 19.368 23 18 23c-2.404 0-4.664.936-6.364 2.636l-5 5c-1.564 1.563-2.481 3.6-2.618 5.787C4.006 36.614 4 36.807 4 37c0 2.404.936 4.664 2.636 6.364C8.336 45.064 10.596 46 13 46s4.664-.936 6.364-2.636l5-5C26.064 36.664 27 34.404 27 32c0-1.368-.313-2.686-.888-3.884L24.586 29.642z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M31 19L19 31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7eb1bbdc7bfab8d6aced10e24bbded96.svg";
export { ForwardRef as ReactComponent };